import { UNASSIGNED_COLUMN } from '@/coreDomainsModule/constants';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { convertLeadTimeToDays } from '@/coreDomainsModule/leadtime';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { AggregateBusinessPostRequest } from '@/coreInfrastructureModule/axios/generated/aggregateBusinessManage';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';

/**
 * 新規に集計取引を作成する
 */
export class CreateNewAggregateBusinessUseCase {
  private repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - 集計情報のリポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }

  /**
   * 新しい取引情報を作成する
   * @param business - 取引情報
   */
  public async Execute(business: IBusiness): Promise<INetworkResult<string, Error>> {
    try {
      const request: AggregateBusinessPostRequest = {
        postAggregateBusinessInfo: {
          supplierName: business.supplierName,
          supplierNumber: business.supplierNumber,
          businessNumber: business.businessNumber,
          businessName: business.businessName,
          package: business.package,
          warehouse: business.warehouse,
          warehouseNumber: business.warehouseNumber,
          unit: business.unit ?? '',
          manufacturer: business.manufacturer,
          leadTime: (business.leadTime || 0).toString(),
          leadTimeUnit: business.leadTimeUnit || '',
          stdInventoryIndicesMin: (business.stdInventoryIndices?.標準在庫指数.min || 0).toString(),
          stdInventoryIndicesMax: (business.stdInventoryIndices?.標準在庫指数.max || 0).toString(),
          stdInventoryIndicesUnit: business.stdInventoryIndices?.標準在庫指数.option.unit || '',
          moq: business.MOQ?.toString(),
          executionDate: DateService.formatDateToISOString(new Date(1000)),
          orderPackage: business.orderPackage?.toString(),
          aggregateBusinessResponsibleUserIdList:
            business.aggregateBusinessResponsibleUsers?.map((user) => user.email).filter((userId) => userId !== undefined) ?? [],
          businessFreeColumnValues: business.businessFreeColumnValues
            ?.filter((column) => column.isConfigured && (column.target === 'aggregate' || column.target === undefined))
            .map((column) => ({ columnNo: column.columnNo, value: column.value })),
        },
      };
      const result = await this.repository.post(request);

      if (result.status.type === 'error') {
        return {
          status: {
            type: 'error',
            error: Error('取引情報の作成に失敗しました'),
          },
        };
      }

      return {
        status: {
          type: 'success',
          data: result.status.data.aggregateBusinessId,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取引情報の作成に失敗しました'),
        },
      };
    }
  }
}
